import { render, staticRenderFns } from "./WorkLocationTab.vue?vue&type=template&id=c526dbbe&scoped=true"
import script from "./WorkLocationTab.vue?vue&type=script&lang=js"
export * from "./WorkLocationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c526dbbe",
  null
  
)

export default component.exports